export default __webpack_public_path__ + "static/media/IMG3693.71779e15.jpg";